import type { ReactNode } from "react";

import { tv } from "tailwind-variants";

const messageActionsVariants = tv({
	base: "flex flex-wrap items-center gap-1",
	variants: {
		align: {
			left: "-ml-2 justify-start",
			chatbotleft: "ml-8 justify-start",
			right: "-mr-2 justify-end",
		},
	},
	defaultVariants: {
		align: "left",
	},
});

interface MessageActionsProps {
	readonly children: ReactNode;
	readonly align: "left" | "right" | "chatbotleft";
}

export default function MessageActions({ children, align = "left" }: MessageActionsProps) {
	return <div className={messageActionsVariants({ align })}>{children}</div>;
}
